import { render, staticRenderFns } from "./BgqwPage17.vue?vue&type=template&id=5236a6ed"
import script from "./BgqwPage17.vue?vue&type=script&lang=js"
export * from "./BgqwPage17.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports